export default [
  {
    label: 'FANTASY CRICKET',
    key: 'FANTASY_CRICKET',
    active: true,
    gameTypeList: [
      {
        label: 'STANDARD',
        key: 'CRICKET',
        active: true
      },
      {
        label: 'SUBSTITUTION',
        key: 'SUBSTITUTION',
        active: false
      }
    ]
  },
  {
    label: 'FANTASY KABADDI',
    key: 'KABADDI',
    active: false,
    gameTypeList: []
  },
  {
    label: 'Poker',
    key: 'POKER',
    active: false,
    gameTypeList: []
  },

  {
    label: 'Offers',
    key: 'OFFERS',
    active: false,
    gameTypeList: []
  },
  {
    label: 'Trump Card',
    key: 'TRUMP_CARD',
    active: false,
    gameTypeList: []
  }
  // {
  //   label: 'FAQ',
  //   key: 'FAQ',
  //   active: false
  // },
  // {
  //   label: 'REFER & EARN',
  //   key: 'REFER&EARN',
  //   active: false,
  //   gameTypeList: []
  // }
];
